import { render } from "./NcrmDealWonHandoffDialog.vue?vue&type=template&id=4eacb1a3&scoped=true"
import script from "./NcrmDealWonHandoffDialog.vue?vue&type=script&lang=js"
export * from "./NcrmDealWonHandoffDialog.vue?vue&type=script&lang=js"

import "./NcrmDealWonHandoffDialog.vue?vue&type=style&index=0&id=4eacb1a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eacb1a3"]])

export default __exports__